<template>
  <div class="accountDisclaimer flex flex-col items-start justify-start">
    <div class="text-sm text-left w-full flex items-center justify-start gap-2.5">
      <el-checkbox :value="currChecked" @change="checkboxOnChange" class="w-auto" />
      <el-button type="text" class="p-0 flex-1 text-start" data-testid="checkbox" @click="() => (isExpand = !isExpand)">
        <div class="flex items-center justify-between text-blackG3">
          <div class="whitespace-normal">
            {{ $t('verificationStatus.openAccount.accountConfiguration.disclaimerLabel') }}
          </div>
          <i :class="isExpand ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="text-lg text-black" /></div
      ></el-button>
    </div>
    <div
      :class="isExpand ? 'max-h-1000' : 'max-h-0'"
      class="overflow-hidden transition-max-height duration-300 ease-in-out"
    >
      <ol
        class="py-3"
        v-if="countryIran"
        v-html="
          $t('openAdditAcc.svg.disclaimerIran', {
            platform: $config.info.fullName,
            platformEntityName: $config.info.entityName,
            regulatorUrl: disclaimerUrl
          })
        "
      ></ol>
      <ol
        class="py-3"
        v-else
        v-html="
          $t('openAdditAcc.svg.disclaimer', {
            platform: $config.info.fullName,
            platformEntityName: $config.info.entityName,
            regulatorUrl: disclaimerUrl
          })
        "
      ></ol>
    </div>
  </div>
</template>

<script>
import { countryCodeEnum } from '@/constants/country';

export default {
  name: 'AccountDisclaimer',
  props: {
    currChecked: { type: Boolean, required: true },
    checkboxOnChange: { type: Function, required: true }
  },
  data() {
    return { isExpand: false };
  },
  computed: {
    countryIran() {
      return this.$store.state.common.countryCode == countryCodeEnum.IRAN ? true : false;
    },
    isGlobalCnHost() {
      const hostnames = ['myaccount.securevtmarketscn.com'];
      return hostnames.includes(location.hostname);
    },
    isBackupGlobalCnHost() {
      const hostnames = ['myaccount.vtmarketstrade.com'];
      return hostnames.includes(location.hostname);
    },
    disclaimerUrl() {
      return this.isGlobalCnHost
        ? 'www.vtmarketsglobalcn.com'
        : this.isBackupGlobalCnHost
        ? 'www.vtmarketstrade.com'
        : this.GLOBAL_DOMAIN_WEBSITE;
    }
  }
};
</script>

<style lang="scss" scoped>
.accountDisclaimer ::v-deep {
  ol {
    li {
      list-style: decimal;
      list-style-position: inside;
      color: #323232;
      font-size: 12px;
      line-height: 16.8px;
    }
  }
  a {
    color: $primary-blue;
    text-decoration: underline;
  }
}
</style>
